import type { HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

const padding = {
  none: '',
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-5',
} as const

export interface OverlayBodyProps extends HTMLAttributes<HTMLDivElement> {
  padding?: keyof typeof padding
}

export function OverlayBody({
  padding: pad = 'lg',
  className,
  children,
  ...props
}: OverlayBodyProps) {
  return (
    <div
      // `min-h-0` is load-bearing beside `flex-1`: a flex child's default
      // `min-height: auto` refuses to shrink below its content, so a body
      // taller than the overlay pushed the footer out of the box instead of
      // scrolling. On a phone that put the drawer's own Save and Cancel under
      // the scrolling body — present, reported visible, and unclickable.
      className={cn('min-h-0 flex-1 overflow-y-auto', padding[pad], className)}
      {...props}
    >
      {children}
    </div>
  )
}
